import {Model} from 'vue-mc';
import moment from 'moment'
// Validation rules
import {
    boolean,
    equal,
    integer,
    min,
    required,
    string,
    length,
    email
} from 'vue-mc/validation'


/**
 * Contact model
 */
export default class BookingModel extends Model {

    options() {
        return {
            methods: {
                create: 'POST',
            }
        }
    }

    // Default attributes that define the "empty" state.
    defaults() {
        return {
            country_id: '',
            state_id: '',
            clinic_ward: '',
            selected: false,
            ref_num: "",
            senderName: '',
            Created: '',
            mobile: '',
            phone: '',
            email: '',
            serviceDate: '',
            language: '',
            startTime: '',
            endTime: '',
            location: '',
            locationId: '',
            locationName: '',
            jobStatus: '',
            cancellation_date: '',
            address: '',
            address2: '',
            location_address1: '',
            location_address2: '',
            suburb: '',
            postCode: '',
            requestedGender: '',
            jobType: '',
            interpreter: '',
            interpreterGender: '',
            requestedInterpreter: '',
            professional: '',
            additionalData: '',
            department: '',
            dialect: '',
            duration: '',
            local_only: false,
            confirm_by: '',
            requested_gender_pref: '',
            accred_type: '',
            acrred_description: '',
            cnpNumber: '',
            CALD: '',
            isHomeVisit: false,
            interpCat: '',
            noOfClients: '',
            client_ref_no: '',
            location_details: '',
            interpretingCategory: '',
            cancellationReason: 'Web booking cancellation',
            nebs: [{
                key: 1,
                value: '',
                name: "",
                reference: "",
                gender: "",
                when: "",
                where: "",
                professional: ""

            }],
	        service_date_safari: '',
	        start_safari: '',
	        end_safari: ''
        }
    }

    options() {
        return {
            validateOnChange: true,
            validateOnSave: true,
            validateRecursively: true,
        }
    }

    validation() {
        let localThis = this;
        return {
            senderName: string.and(required).and(length(3, 100)),
            email: string.and(required).and(email),
            phone: required.and(length(2, 25)),
            startTime: required,
            jobType: required,
            endTime: (value) => {
                if (value === "" && localThis.duration === "") {
                    return "End time is required";
                } else if (localThis.duration !== "") {
                    debugger;
                    let endTime = moment(localThis.startTime, 'HH:mm').add(localThis.duration, 'hours').format('HH:mm');
                    localThis.endTime = endTime.toString();
                }
            },
            duration: (value) => {
                if (value === "" && localThis.endTime === "") {
                    return "Duration is required";
                }
            },
            serviceDate: required,
            language: required,
            locationId: required
            /* location_address1:
                (value) => {
                    if (value != null && (value.length < 2 || value.length > 250)) {
                        return "Must have a length between 2 and 250";
                    }
                },*/
            /*location_address2:
                (value) => {
                    if (value != null && (value.length < 2 || value.length > 250)) {
                        return "Must have a length between 2 and 250";
                    }
                },*/
        }
    }

    // Route configuration
    routes() {
        return {
            save: "job/test",
            fetch: "jobs/"
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/bookingModel.js